module.exports = __webpack_public_path__ + "static/img/g3.5edf19c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/g3.svg
// module id = 8lia
// module chunks = 0